import React, { useState } from 'react';
import './KnowledgeForm.css';

function KnowledgeForm({ item, onSave, onClose }) {
    const [formData, setFormData] = useState({
        category: item?.category || 'general',
        item_name: item?.item_name || '',
        value: item?.value || '',
        price: item?.price || '',
        unit: item?.unit || '',
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <div className="modal-overlay">
            <form className="modal-content knowledge-form" onSubmit={handleSubmit}>
                <h2>{item ? 'Edit Item' : 'Add Item'}</h2>

                <div className="form-group" style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 600 }}>Category</label>
                    <select value={formData.category}
                        onChange={e => setFormData(f => ({ ...f, category: e.target.value }))}
                        className="select"
                        style={{ width: '100%' }}>
                        <option value="general">General</option>
                        <option value="menu">Menu</option>
                        <option value="hours">Hours</option>
                        <option value="faq">FAQ</option>
                        <option value="policy">Policy</option>
                    </select>
                </div>

                <div className="form-group" style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 600 }}>Name</label>
                    <input value={formData.item_name}
                        onChange={e => setFormData(f => ({ ...f, item_name: e.target.value }))}
                        className="input"
                        style={{ width: '100%' }}
                        placeholder="e.g. Idli or Opening Hours" required />
                </div>

                <div className="form-group" style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 600 }}>Value / Details</label>
                    <textarea value={formData.value}
                        onChange={e => setFormData(f => ({ ...f, value: e.target.value }))}
                        className="textarea"
                        style={{ width: '100%' }}
                        placeholder="e.g. ₹25 per plate or 8AM - 10PM" required rows={3} />
                </div>

                {formData.category === 'menu' && (
                    <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
                        <div className="form-group">
                            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 600 }}>Price (₹)</label>
                            <input type="number" value={formData.price}
                                onChange={e => setFormData(f => ({ ...f, price: e.target.value }))}
                                className="input"
                                style={{ width: '100%' }}
                                placeholder="25" />
                        </div>
                        <div className="form-group">
                            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 600 }}>Unit</label>
                            <input value={formData.unit}
                                onChange={e => setFormData(f => ({ ...f, unit: e.target.value }))}
                                className="input"
                                style={{ width: '100%' }}
                                placeholder="e.g. plate, cup" />
                        </div>
                    </div>
                )}

                <div className="form-actions space-between" style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <button type="button" className="btn" onClick={onClose}>Cancel</button>
                    <button type="submit" className="btn primary">Save Info</button>
                </div>
            </form>
        </div>
    );
}

export default KnowledgeForm;
